import { render } from "./CXFirstAidSettings.vue?vue&type=template&id=87f633ee&scoped=true"
import script from "./CXFirstAidSettings.vue?vue&type=script&lang=js"
export * from "./CXFirstAidSettings.vue?vue&type=script&lang=js"

import "./CXFirstAidSettings.vue?vue&type=style&index=0&id=87f633ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f633ee"]])

export default __exports__